import { call, put } from 'redux-saga/effects';
import { formatMessage } from 'devextreme/localization';
import notify from 'devextreme/ui/notify';
import * as actions from '../actions/userManual';
import { get, post, axiosPut, del } from '../../utils/api';
import { modalErrorOpen } from '../actions/modalError';
import { errorModalOpen, getLocale } from '../../utils/functions';

export function* getUserManual({ payload }) {
  try {
    const data = window.btoa(
      unescape(
        encodeURIComponent(
          JSON.stringify({
            restMethod: 'getFile',
            url: `/instruction/${payload.shippingType}`
          })
        )
      )
    );
    const newWindow = window.open(`/pdf-viewer/${data}`, '_blank');
    newWindow.opener = null;
  } catch (e) {
    yield put(
      modalErrorOpen({
        message: e.response.data.message,
        techInfo: e.response.data.techInfo,
        types: 'info',
        title: formatMessage('textError').warning
      })
    );
    yield put(actions.getUserManualFail());
  }
}

export function* setUserManual({ payload }) {
  try {
    const formData = new FormData();
    formData.append('file', payload.file);
    notify(
      {
        message: 'Пожалуйста, подождите',
        height: 64,
        width: 354,
        position: {
          at: 'top center',
          my: 'top center',
          offset: '0 48'
        }
      },
      'info',
      2000
    );
    yield call(
      post,
      `/instruction/${payload.shippingType}`,
      formData,
      {
        headers: {
          'Accept-Language': getLocale(),
          'Content-Type': 'multipart/form-data'
        }
      }
    );
    yield put(actions.setUserManualSuccess());
    notify(
      {
        message: 'Файл успешно обработан',
        height: 64,
        width: 354,
        position: {
          at: 'top center',
          my: 'top center',
          offset: '0 48'
        }
      },
      'success',
      2000
    );
  } catch (e) {
    yield put(
      modalErrorOpen({
        message: e.response.data.message,
        techInfo: e.response.data.techInfo,
        types: 'info',
        title: formatMessage('textError').warning
      })
    );
    yield put(actions.setUserManualFail());
  }
}

export function* getListChapters({ payload }) {
  try {
    const response = yield call(get, `/manual/chapter/list/${payload.plantId}`);
    yield put(actions.getListChaptersSuccess(response));
  } catch (error) {
    yield put(errorModalOpen(error));
    yield put(actions.getListChaptersFail());
  }
}

export function* addOrEditChapter({ payload }) {
  try {
    let response = '';
    if (payload.chapterNumId !== null) {
      response = yield call(axiosPut, '/manual/chapter/update',
        {
          manualChapterNumId: payload.chapterNumId,
          shippingType: payload.shippingType,
          title: payload.chapterTitle
        });
    } else {
      response = yield call(post, '/manual/chapter',
        {
          shippingType: payload.shippingType,
          title: payload.chapterTitle
        });
    }
    yield put(actions.addOrEditChapterSuccess(response));
    response = yield call(get, `/manual/chapter/list/${payload.plantId}`);
    yield put(actions.getListChaptersSuccess(response));
  } catch (error) {
    yield put(errorModalOpen(error));
    yield put(actions.addOrEditChapterFail());
  }
}

export function* deleteChapter({ payload }) {
  try {
    let response = yield call(del, `/manual/chapter/${payload.chapterNumId}`);
    yield put(actions.deleteChapterSuccess(response));
    response = yield call(get, `/manual/chapter/list/${payload.plantId}`);
    yield put(actions.getListChaptersSuccess(response));
  } catch (error) {
    yield put(errorModalOpen(error));
    yield put(actions.deleteChapterFail());
  }
}

export function* moveChapter({ payload }) {
  try {
    let response = '';
    response = yield call(axiosPut,
      `/manual/chapter/update_order?manualChapterNumId=${payload.chapterNumId}&changeSortOrder=${payload.sortOrder}`);
    yield put(actions.moveChapterSuccess(response));
    response = yield call(get, `/manual/chapter/list/${payload.plantId}`);
    yield put(actions.getListChaptersSuccess(response));
  } catch (error) {
    yield put(errorModalOpen(error));
    yield put(actions.moveChapterFail());
  }
}

// eslint-disable-next-line consistent-return
export function* addOrEditManual({ payload }) {
  try {
    let response = '';
    if (payload.manualNumId) {
      response = yield call(axiosPut, '/manual/update',
        {
          descr: payload.manualDescr,
          isActiveFlag: payload.isActiveFlag,
          manualChapterNumId: payload.chapterNumId,
          manualNumId: payload.manualNumId,
          title: payload.manualTitle
        });
    } else {
      const formData = new FormData();
      formData.append('descr', payload.manualDescr);
      formData.append('manualChapterNumId', payload.chapterNumId);
      formData.append('title', payload.manualTitle);
      formData.append('file', payload.file);
      response = yield call(post, '/manual', formData,
        {
          headers: {
            'Accept-Language': getLocale(),
            'Content-Type': 'multipart/form-data'
          }
        });
    }
    yield put(actions.addOrEditManualSuccess(response));
    response = yield call(get, `/manual/chapter/list/${payload.plantId}`);
    yield put(actions.getListChaptersSuccess(response));
  } catch (error) {
    yield put(errorModalOpen(error));
    yield put(actions.addOrEditManualFail());
  }
}

export function* deleteManual({ payload }) {
  try {
    let response = yield call(del, `/manual/${payload.manualNumId}`);
    yield put(actions.deleteManualSuccess(response));
    response = yield call(get, `/manual/chapter/list/${payload.plantId}`);
    yield put(actions.getListChaptersSuccess(response));
  } catch (error) {
    yield put(errorModalOpen(error));
    yield put(actions.deleteManualFail());
  }
}

export function* moveManual({ payload }) {
  try {
    let response = '';
    response = yield call(axiosPut,
      `/manual/update_order?changeSortOrder=${payload.sortOrder}&manualNumId=${payload.manualNumId}`);
    yield put(actions.moveManualSuccess(response));
    response = yield call(get, `/manual/chapter/list/${payload.plantId}`);
    yield put(actions.getListChaptersSuccess(response));
  } catch (error) {
    yield put(errorModalOpen(error));
    yield put(actions.moveManualFail());
  }
}

export function* videoViewerByStockOpen({ payload }) {
  try {
    const response = yield call(get, `/manual/chapter/list/${payload.plantId}`);
    const manualsList = [];
    // eslint-disable-next-line no-case-declarations
    yield response.forEach((itemChapter) => {
      manualsList.push({
        itemNumId: 1000000 + itemChapter.manualChapterNumId,
        manualNumId: null,
        parentItemNumId: null,
        descr: itemChapter.descr,
        description: itemChapter.title,
        title: itemChapter.title,
        fileName: null,
        filePath: null
      });
      itemChapter.manualDtoList.forEach((itemManual) => {
        manualsList.push({
          itemNumId: itemManual.manualNumId,
          manualNumId: itemManual.manualNumId,
          parentItemNumId: 1000000 + itemChapter.manualChapterNumId,
          descr: itemManual.descr,
          description: itemManual.title,
          title: itemManual.title,
          fileName: itemManual.attachmentDto.originalFileName,
          filePath: itemManual.attachmentDto.storedFileUrl
        });
      });
    });
    yield put(actions.videoViewerByStockOpenSuccess({
      chaptersManualsList: response,
      manualsList
    }));
  } catch (error) {
    yield put(errorModalOpen(error));
    yield put(actions.videoViewerByStockOpenFail());
  }
}
